import "./Contact.css";

function Contact() {

    return (

        <div className="contact-container">

            <span className="section-tag">
                CONTACT
            </span>

            <h2>

                Ready to Start Your Next Sign Project?

            </h2>

            <p className="contact-intro">

                Whether you need a new storefront sign, custom fabrication or
                professional installation, our team is ready to help.

            </p>

            <div className="contact-card">

                <div className="contact-item">

                    <h3>📍 Address</h3>

                    <p>

                        Montreal, Quebec

                    </p>

                </div>

                {/* <div className="contact-item">

                    <h3>📞 Phone</h3>

                    <p>

                        Provided after first email.

                    </p>

                </div> */}

                <div className="contact-item">

                    <h3>✉ Email</h3>

                    <p>

                        info@3pointsigns.com

                    </p>

                </div>

                <div className="contact-item">

                    <h3>🕒 Business Hours</h3>

                    <p>

                        Monday – Friday<br />

                        8:30 AM – 4:30 PM

                    </p>

                </div>

            </div>

            <button className="contact-button">

                <a
                    href={`mailto:info@3pointsigns.com?subject=Request%20for%20a%20Quote&body=Hello%203%20Point%20Signs,%0D%0A%0D%0AI%20would%20like%20to%20request%20a%20quote%20for%20a%20new%20signage%20project.%0D%0A%0D%0AThank%20you!`}

                    style={{ color: "white", textDecoration: "none" }}
                >

                    Request a Quote

                </a>
            </button>

        </div>

    );

}

export default Contact;